// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"d7db1031","116":"b706c067","444":"5e7f1a73","488":"b62a96c6"}[chunkId] + ".chunk.css";
};